import type { PlayerPermissions } from '../../../src/web-player/contracts.js'

export interface PermissionSync {
  value: PlayerPermissions | null
  retiredStreams: string[]
}
export function createPermissionSync(): PermissionSync {
  return { value: null, retiredStreams: [] }
}
export function applyPermissionSnapshot(
  current: PermissionSync,
  incoming: PlayerPermissions
): PermissionSync {
  const next = incoming.sync
  const previous = current.value?.sync
  if (previous && !next) return current
  if (next && current.retiredStreams.includes(next.streamId)) return current
  if (previous && next && previous.streamId === next.streamId && next.revision <= previous.revision)
    return current
  return {
    value: incoming,
    retiredStreams:
      previous && next && previous.streamId !== next.streamId
        ? [...current.retiredStreams, previous.streamId].slice(-16)
        : current.retiredStreams,
  }
}
